module.exports = __webpack_public_path__ + "img/partners10.91801783.jpg";